import PropTypes from "prop-types";
import WrapContainer from "./WrapContainer";
import RightWrap from "./RightWrap";
import LeftWrap from "./LeftWrap";

const LeftRightWrap = (props) => {
  return (
    <WrapContainer>
      {props.isRight ? (
        <RightWrap children={props.children} />
      ) : (
        <LeftWrap children={props.children} />
      )}
    </WrapContainer>
  );
};

LeftRightWrap.defaultProps = {
  isRight: false,
};

LeftRightWrap.propTypes = {
  children: PropTypes.node,
  isRight: PropTypes.bool,
};

export default LeftRightWrap;
